import { Guid } from "@/types"
import Address, { IAddressDto } from "./Address"
import Location, { ILocationDto } from "./Location"

export interface ITenantWarehouseDto {
    id: Guid
    description: string
    responsibleStockManagerId: Guid
    location: ILocationDto
    address: IAddressDto
    geofenceRadius: number
    isPreferred: boolean
    matchingAssetCount?: number | null
}

export interface ICreateTenantWarehouseDto {
    description: string
    responsibleStockManagerId: Guid
    location: ILocationDto
    address: IAddressDto
    geofenceRadius: number
    isPreferred: boolean
}

export type TenantWarehouseLabelData = Pick<TenantWarehouse, 'id' | 'description'>
export class TenantWarehouse {
    id: Guid
    description: string
    responsibleStockManagerId: Guid
    location: Location
    address: Address
    geofenceRadius: number
    isPreferred: boolean
    matchingAssetCount?: number | null

    constructor(dto: ITenantWarehouseDto) {
        this.id = dto.id
        this.description = dto.description
        this.responsibleStockManagerId = dto.responsibleStockManagerId
        this.location = new Location(dto.location)
        this.address = new Address(dto.address)
        this.geofenceRadius = dto.geofenceRadius
        this.isPreferred = dto.isPreferred
        this.matchingAssetCount = dto.matchingAssetCount ?? null
    }

    toDto(): ITenantWarehouseDto {
        return {
            id: this.id,
            description: this.description,
            responsibleStockManagerId: this.responsibleStockManagerId,
            location: this.location.toDto(),
            address: this.address.toDto(),
            geofenceRadius: this.geofenceRadius,
            isPreferred: this.isPreferred,
        }
    }
}
